import { render, staticRenderFns } from "./CustomerSetStatusModal.vue?vue&type=template&id=1d538490"
import script from "./CustomerSetStatusModal.vue?vue&type=script&lang=js"
export * from "./CustomerSetStatusModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports